import { useState, useEffect } from 'react'
import { useClient } from 'sanity'

export default function CustomDocumentActions(props) {
    const client = useClient()
    const [hasHomeDocument, setHasHomeDocument] = useState(false)

    useEffect(() => {
        const checkHomeDocument = async () => {
            const query = '*[_type == "home"]'
            const result = await client.fetch(query)
            setHasHomeDocument(result.length > 0)
        }
        checkHomeDocument()
    }, [client])

    if (props.type === 'home' && hasHomeDocument) {
        return []
    }

    return props.renderDefault(props)
} 